import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import hospitalReducer from './hospitalSlice';
import cityReducer from './citySlice';
import schoolReducer from './schoolSlice';
import zoneReducer from './zoneSlice';
import languageReducer from './languageSlice';

import stateReducer from './stateSlice';
import interpreterReducer from './interpreterSlice';
import vendorReducer from './vendorSlice';
import adminReducer from './adminSlice';
import profileReducer from './profileSlice';
import availibilityReducer from './availibilitySlice';
import scheduleReducer from './scheduleSlice';

import typesReducer from './typeSlice';
import accountReducer from './accountSlice';

import subUserReducer from './subUserSlice';
import vendorSubUserReducer from './vendorSubUserSlice';

import appointmentReducer from './appointmentSlice'; // Assuming you have a slice named appointmentSlice
import dashboardReducer from './dashboardSlice'; // Assuming you have a slice named appointmentSlice
import permissionReducer from './permissionGroupSlice'; // Assuming you have a slice named appointmentSlice
import appReducer from './appSlice'; // Assuming you have a slice named appointment

import actionButtonReducer from './actionButtonSlice'; // Assuming you have a slice named appointment
import inviteInterpreterReducer from './inviteInterpreterSlice'; // Assuming you have a slice named appointment
import interviewInvitesReducer from './interviewInviteSlice'; // Assuming you have a slice named appointment
import appointmentDetailsReducer from './appointmentDetailSlice'; // Assuming you have a slice named appointment
import invoiceReducer from './invoiceSlice'; // Assuming you have a slice named appointment
import facilityReducer from './facilitiesSlice'; // Assuming you have a slice named facilitySlice
import departmentReducer from './departmentsSlice'; // Assuming you have a slice named facilitySlice

import mainAccountDashboardReducer from './mainAccount/dashboardSlice'; 
import mainSubAccountReducer from './mainAccount/subAccountSlice';      
import mainAccountInvoiceReducer from './mainAccount/mainAccountInvoiceSlice';      
import mainAccountProfileRefucer from './mainAccount/mainAccountProfileSlice';      
import mainAccountAppointmentReducer from './mainAccount/mainAccountAppointmentSlice'; 
import paymentReducer from './paymentSlice';

import interpreterDashboardReducer from './interpreter/dashboardSlice';
import interpreterPaymentReducer from './interpreter/paymentSlice';
import interpreterProfileRefucer from './interpreter/profileSlice';
import interpreterAppointmentReducer from './interpreter/appointmentSlice';
import declinedAppointmentsReducer from './interpreter/declinedAppointmentsSlice';

import vendorDashboardReducer from './vendor/dashboardSlice';
import vendorPaymentReducer from './vendor/paymentSlice';      
import vendorProfileRefucer from './vendor/profileSlice';      
import vendorAppointmentReducer from './vendor/appointmentSlice'; 
import vendorInterpreterReducer from './vendor/interpreterSlice'; 
import translatorReducer from "./TranslatorNameSlice";  
import translationReducer from './translationSlice';

import inviteTranslatorReducer from './inviteTranslatorSlice';
import inviteInterpreterTranslatorReducer from './interpreter/inviteInterpreterTranslatorsSlice';
import interpreterTranslatorReducer from './interpreter/interpreterTranslationSlice';

import translationDetailsReducer from './translationDetailSlice';


export default combineReducers({
    user: userReducer,
    profile: profileReducer,
    hospital: hospitalReducer,
    city: cityReducer,
    schools:schoolReducer,
    zones:zoneReducer,
    language: languageReducer,
    facilities: facilityReducer,
    departments: departmentReducer,
    appointmentDetails:appointmentDetailsReducer,
    state: stateReducer,
    vendor: vendorReducer,
    admin: adminReducer,
    availibility: availibilityReducer, // Assuming you have a slice named availibilitySlice
    schedule: scheduleReducer, // Assuming you have a slice named,
    
    payment: paymentReducer,
    
    // crm slices
    types: typesReducer,
    accounts: accountReducer,

    subUser: subUserReducer,
    vendorSubUser: vendorSubUserReducer,
    interpreter: interpreterReducer,

    appointments: appointmentReducer,
    dashboard : dashboardReducer,
    permission : permissionReducer,
    appStates: appReducer,
    actionButton: actionButtonReducer,

    inviteInterpreters: inviteInterpreterReducer,
    invoices: invoiceReducer,
    interviewInvites: interviewInvitesReducer,

    // main account access 
    mainAccountDashboard : mainAccountDashboardReducer,
    mainSubAccounts: mainSubAccountReducer,
    mainAccountInvoice: mainAccountInvoiceReducer,
    mainAccountProfile: mainAccountProfileRefucer,
    mainAccountAppointments: mainAccountAppointmentReducer,

    // interpreter access
    interpreterDashboard : interpreterDashboardReducer,
    payment: interpreterPaymentReducer,
    interpreterProfile: interpreterProfileRefucer,
    interpreterAppointments: interpreterAppointmentReducer,
    declinedAppointments: declinedAppointmentsReducer,

    // interpreter access
    vendorDashboard : vendorDashboardReducer,
    payment: vendorPaymentReducer,
    vendorProfile: vendorProfileRefucer,
    vendorAppointments: vendorAppointmentReducer,
    vendorInterpreter: vendorInterpreterReducer,
    translators: translatorReducer,
    translation: translationReducer,

     inviteTranslators: inviteTranslatorReducer,
     inviteInterpreterTranslators: inviteInterpreterTranslatorReducer,
     interpreterTranslators: interpreterTranslatorReducer,

    translationDetails: translationDetailsReducer,

});
